import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpPhotographersSsoLogin} from '@features/user/http/user.http.ts'
import {useAuthStore} from '../store/store'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance'
import {z} from 'zod'
import {QUERY_KEYS} from '@/queryClient'

const loginResponseSchema = z.object({
    oauth2_authorization: z.object({
        access_token: z.string(),
        refresh_token: z.string()
    })
})
type LoginResponse = z.infer<typeof loginResponseSchema>
export const usePhotographersSsoLogin = (
    options?: Omit<UseMutationOptions<LoginResponse, unknown, string>, 'queryKey' | 'queryFn'>
) => {
    const setAirbnbTokens = useAuthStore(store => store.setAirbnbTokens)
    const queryClient = useQueryClient()
    return useMutation({
        ...options,
        mutationFn: (code: string) =>
            parseAxiosPromise({
                axiosPromise: httpPhotographersSsoLogin({payload: {code}}),
                responseShape: loginResponseSchema,
                onZodError: captureException
            }),
        onError: (error, variables, context) => {
            options?.onError?.(error, variables, context)
        },
        onSuccess: (data, variables, context) => {
            setAirbnbTokens(data.oauth2_authorization.access_token, data.oauth2_authorization.refresh_token)
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
